/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CountryMetric } from '../models/CountryMetric';
import type { User } from '../models/User';
import type { UserBank } from '../models/UserBank';
import { request as __request } from '../core/request';
import type { ActionResponse } from '../models/ActionResponse';

export class UsersAdminService {

    /**
     * @returns any
     * @throws ApiError
     */
    public static async usersAdminDeleteUser({
        email,
    }: {
        email?: string | null,
    }): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/admin/users`,
            query: {
                'email': email,
            },
        });
        return result.body;
    }

    /**
     * @returns User
     * @throws ApiError
     */
    public static async usersAdminGetUser({
        email,
    }: {
        email?: string | null,
    }): Promise<User> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/users`,
            query: {
                'email': email,
            },
        });
        return result.body;
    }

    /**
     * @returns ActionResponse
     * @throws ApiError
     */
    public static async usersAdminEditUser({
        user,
    }: {
        user: User,
    }): Promise<ActionResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/users/edit`,
            body: user,
        });
        return result.body;
    }

    /**
     * @returns User
     * @throws ApiError
     */
    public static async usersAdminGetAllActiveUsers(): Promise<Array<User>> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/users/active`,
        });
        return result.body;
    }

    /**
     * @returns User
     * @throws ApiError
     */
    public static async usersAdminGetAllInvitedUsers(): Promise<Array<User>> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/users/invited`,
        });
        return result.body;
    }

    /**
     * @returns User
     * @throws ApiError
     */
    public static async usersAdminGetAll({
        withBanks = false,
    }: {
        withBanks?: boolean,
    }): Promise<Array<User>> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/users/all`,
            query: {
                'withBanks': withBanks,
            },
        });
        return result.body;
    }

    /**
     * @returns UserBank
     * @throws ApiError
     */
    public static async usersAdminGetBanks({
        email,
        countryCode,
    }: {
        email?: string | null,
        countryCode?: string | null,
    }): Promise<Array<UserBank>> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/users/banks`,
            query: {
                'countryCode': countryCode,
            },
        });
        return result.body;
    }

    /**
     * @returns UserBank
     * @throws ApiError
     */
    public static async usersAdminSelectBankForUser({
        bank,
        email,
    }: {
        bank: UserBank,
        email?: string | null,
    }): Promise<UserBank> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/users/bank`,
            query: {
                'email': email,
            },
            body: bank,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async usersAdminDeleteSelectedBankForUser({
        bank,
        email,
    }: {
        bank: UserBank,
        email?: string | null,
    }): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/admin/users/bank`,
            query: {
                'email': email,
            },
            body: bank,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async usersAdminEditBankForUser({
        bank,
        email,
    }: {
        bank: UserBank,
        email?: string | null,
    }): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/users/bank/edit`,
            query: {
                'email': email,
            },
            body: bank,
        });
        return result.body;
    }

    public static async banksSelectBank({
        selectedBank,
        email
    }: {
        selectedBank: UserBank,
        email: string,
    }): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/users/banks/select`,
            query: {
                'email': email
            },
            body: selectedBank,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async banksRemoveSelection({
        unselectedBank,
        email
    }: {
        unselectedBank: UserBank,
        email: string,
    }): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/admin/users/banks/select`,
            query: {
                'email': email
            },
            body: unselectedBank,
        });
        return result.body;
    }

    public static async banksGetSelected({
        countryCode,
        email,
    }: {
        countryCode?: string | null,
        email: string,
    }): Promise<Array<UserBank>> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/users/banks/selected`,
            query: {
                'countryCode': countryCode,
                'email': email
            },
        });
        return result.body;
    }

    /**
     * @returns CountryMetric
     * @throws ApiError
     */
    public static async usersAdminGetCountries(): Promise<Array<CountryMetric>> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/users/countries`,
        });
        return result.body;
    }

}